import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width:100%;
  min-width:350px;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width:350px;
  }
`;

export const CardInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 350px;
  border: 1px solid rgba(17, 17, 17, 0.1);
  border-radius: 12px;  
  padding: 24px;
  background: ${({ theme }) => theme.colors.secondary};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

export const CardHeaderContainer = styled.div`
  display: flex;
  flex-direction:column;


  gap: 1rem;
`;

export const CardIcon = styled.div`
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.gold};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textInverted};

`;

export const CardTitle = styled.h4`
  font-weight: bold;
  margin: 0;
  color: ${({ theme }) => theme.colors.text};
`;

export const CardSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.text};
`;
